import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueRouter from 'vue-router'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'

// 关闭 Vue 的生产提示
Vue.config.productionTip = false

// 使用插件
Vue.use(ElementUI) // element ui 插件
Vue.use(VueRouter) // 路由插件
Vue.use(VueAxios, axios) // 使用 axios 插件

// 添加 axios 请求拦截器，自动添加 Authorization 头
axios.interceptors.request.use(
  config => {
    // 从 localStorage 中获取 token
    const token = localStorage.getItem('token');
    // 如果 token 存在，添加到请求头
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  error => {
    // 处理请求错误
    return Promise.reject(error);
  }
)

// 任意接口状态码返回401时，注销登录
axios.interceptors.response.use(
  response => {
    if (response.data && response.data.code === 401) {
      // 从 localStorage 中移除 token
      localStorage.removeItem('token');
      // 从 localStorage 中移除用户信息
      localStorage.removeItem('userInfo');

      // 跳转到登录页
      router.push('/login');
      return Promise.reject(new Error('请重新登录'));
    }
    return response;
  },
  error => {
    // 处理响应错误
    return Promise.reject(error);
  }
)

// 创建 Vue 实例对象
new Vue({
  render: h => h(App),  // render 函数将帮助解析模板，传入的参数 h 为一个函数，该函数可用来解析 App 这个组件
  router
}).$mount('#app') // 将 App.vue 组件挂载到 index.html 中的 id 为 app 的 div 标签上

